// extracted by mini-css-extract-plugin
module.exports = {"downloadBtn":"Header_downloadBtn__1I3qb"};